import React,{useState,useEffect} from "react";
import tw from "twin.macro";
import ReactPlayer from 'react-player'
import Modal from 'react-modal'
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/headers/light";
import HomeNewsFeed from "components/blogs/NewsFeed";
import Footer from "components/Footer";
import MoviesCard from "../../components/cards/ThreeColSlider";
import HomeMovieFeed from "components/blogs/HomeMovieFeed";
import {AiOutlineClose} from "react-icons/ai";
import HomeActorImage from "components/blogs/HomeActorImage";
import HomeActressImage from "components/blogs/HomeActressImage";
import {useAppDispatch, topTrailer, loadNews, loadMovie, loadActor, loadActress, useAppSelector} from "../../redux";
import {auth} from '../../FirebaseInit'
import AdComponent from "components/AdComponent";



const Div = tw.div`w-full px-5 py-2 lg:py-4 z-50 fixed bg-white`;
const Hr = tw.hr`mt-2`
const DivFlex = tw.div`flex justify-end items-center cursor-pointer pb-4 pr-2`
const One = tw.div`lg:m-3 `
const Container = tw.div`max-w-screen-xl mx-auto`;
const ContentWithPaddingXl = tw.div`max-w-screen-xl mx-auto lg:flex justify-center `


export default () => {
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false)
  const [getUrl, setGetUrl] = useState("")



 const trailer = useAppSelector(state => state.topTrailer.trailer)
  const news = useAppSelector(state => state.news.news)
  const movie = useAppSelector(state => state.movie.movie)
  const actor = useAppSelector(state => state.actor.actor)
  const actress = useAppSelector(state => state.actress.actress)

  const customStyles = {
    content : {
      top                   : '55%',
      left                  : '10%',
      right                 : '10%',
      bottom                : '-40%',
      marginRight           : '-40%',
      marginLeft:'40%',
      transform             : 'translate(-50%, -50%)',
      overflow: 'hidden',
     
    }
  };
  const ModalOpen=(value)=>{
   setOpen(true)
   setGetUrl(value)
  }
  useEffect(() => {
    const user = auth.currentUser;
    console.log(user);
    dispatch(topTrailer())
    dispatch(loadNews())
    dispatch(loadMovie())
    dispatch(loadActor())
    dispatch(loadActress())
  }, [dispatch])

  return (
    <>
      <Div>
        <Hero />
        <Hr />
      </Div>
      <AnimationRevealPage>
        <MoviesCard trailer={trailer} ModalOpen={ModalOpen}/>
      </AnimationRevealPage>
      <Container>
        <ContentWithPaddingXl>
          <One>
            <HomeNewsFeed news={news} />
          </One>
        </ContentWithPaddingXl>
      </Container>
      <AdComponent/>
      <HomeMovieFeed headingText={"Movie"} movie={movie} />
      <HomeActorImage headingText={"Actor"} actor={actor}/>
      <HomeActressImage headingText={"Actress"} actress={actress}/>
      <div>

      <Modal isOpen={open}
      style={customStyles}>
          <DivFlex>
            <AiOutlineClose className="cursor-pointer" onClick={() => open ? setOpen(!open) : setOpen(open)} />
          </DivFlex>
      <ReactPlayer
       width="100%"
       height="95%"
      controls
       url={getUrl}
       />
       
      </Modal>
      </div>


    
      
      
      <Footer />
    </>
  );
};
